export const PAYMENTS_CREATE_ACCOUNT = 'paymentsCreateAccount'
export const PAYMENTS_SET_ACCOUNT = 'paymentsSetAccount'
export const PAYMENTS_SET_PAYMENT_METHODS = 'paymentsSetPaymentMethods'
export const PAYMENTS_ADD_PAYMENT_METHOD = 'paymentsAddPaymentMethod'
export const PAYMENTS_SET_MEMBERSHIP_FEE = 'paymentsSetMembershipFee'
export const PAYMENTS_SET_SETUP_INTENT = 'paymentsSetSetupIntent'
export const PAYMENTS_SET_PAYMENTS = 'paymentsSetPayments'
export const PAYMENTS_SET_LATEST_PAYMENT = 'paymentsSetLatestPayment'
export const PAYMENTS_SET_REVENUE_PROJECTION = 'paymentsSetRevenueProjection'
export const PAYMENTS_SET_REFUNDS = 'paymentsSetRefunds'
export const PAYMENTS_SET_ACCOUNT_OWNERS = 'paymentsSetAccountOwners'
export const PAYMENTS_SET_ACCOUNT_REPRESENTATIVE = 'paymentsSetAccountRepresentative'
export const PAYMENTS_SET_STRIPE_ACCOUNT = 'paymentsSetStripeAccount'